import * as React from 'react';
import { Title } from '../../../title';
import { I18n } from 'react-redux-i18n';
import { FieldPicker, FieldPickerOnChangeValue } from '../../../field-picker';
import { FolderPrimaryListDto } from '@common/dto/folder/primary-list-dto';
import { QuestionnaireFolderField } from '@modules/fhq-design-tool/types/field';
import { FieldPrimaryListDto } from '@common/dto/field/list-primary-dto';
import { QuestionnaireUpdateLocalDto } from '@modules/fhq-design-tool/dto/questionnaire-update-local-dto';
import { QuestionnaireCreateLocalDto } from '@modules/fhq-design-tool/dto/questionnaire-create-local-dto';

import './rename-pedigree-on-submit.styles.scss';

export type RenamePedigreeOnSubmitProps = {
  getFields: (params: { folderId?: number }) => Promise<QuestionnaireFolderField[]>;
  getFolders: () => Promise<FolderPrimaryListDto[]>;
  questionnaire: QuestionnaireUpdateLocalDto | QuestionnaireCreateLocalDto;
  onChange: (questionnaire: QuestionnaireUpdateLocalDto | QuestionnaireCreateLocalDto) => void;
};

export const RenamePedigreeOnSubmit: React.FC<RenamePedigreeOnSubmitProps> = (props) => {
  const { getFields, getFolders, onChange, questionnaire } = props;

  const handleRenamePedigreeOnSubmit1Change = React.useCallback((value: FieldPickerOnChangeValue | undefined) => {
    onChange({
      ...questionnaire,
      statusTab: {
        ...questionnaire.statusTab,
        renamePedField1Id: value ? value.field.id as FieldPrimaryListDto['id'] : undefined,
        renamePedField1Name: value ? value.field.name : undefined,
        renamePedField1System: value ? value.field.system : undefined,
      },
    });
  }, [onChange, questionnaire]);

  const handleRenamePedigreeOnSubmit2Change = React.useCallback((value: FieldPickerOnChangeValue | undefined) => {
    onChange({
      ...questionnaire,
      statusTab: {
        ...questionnaire.statusTab,
        renamePedField2Id: value ? value.field.id as FieldPrimaryListDto['id'] : undefined,
        renamePedField2Name: value ? value.field.name : undefined,
        renamePedField2System: value ? value.field.system : undefined,
      },
    });
  }, [onChange, questionnaire]);

  return (
    <div className="FhqDesignToolStatusActionsRenamePedigreeOnSubmit">
      <Title text={I18n.t('Rename Pedigree on Submit')} />
      <FieldPicker 
        clearable
        withSearch={true}
        value={questionnaire.statusTab.renamePedField1Name ?? undefined}
        labelWidth={100}
        onChange={handleRenamePedigreeOnSubmit1Change}
        metadata={{
          description: 'rename-pedigree-on-submit-1',
        }}
        getFields={getFields}
        getFolders={getFolders}
        label={I18n.t('Field 1')}
      />
      <FieldPicker 
        clearable
        withSearch={true}
        value={questionnaire.statusTab.renamePedField2Name ?? undefined}
        labelWidth={100}
        onChange={handleRenamePedigreeOnSubmit2Change}
        metadata={{
          description: 'rename-pedigree-on-submit-2',
        }}
        getFields={getFields}
        getFolders={getFolders}
        label={I18n.t('Field 2')}
      />
    </div>
  );
};